import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import { CompGroup } from "userful-chronos-app-common-js/dist/models/group/Groups";
import {
    NOTIFY_CREATE_GROUP,
    NOTIFY_REMOVE_GROUP,
    NOTIFY_UPDATE_GROUP,
    RESPONSE_LIST_GROUPS,
} from "userful-chronos-app-common-js/dist/models/group/messages/msgTypes";
import { groupSliceActions } from "../groupSlice";
import groupStore from "../groupStore";

registerMsgHandler(RESPONSE_LIST_GROUPS, (payload) => {
    const data = JSON.parse(payload) as CompGroup[];

    console.debug(data);

    groupStore.dispatch(groupSliceActions.setGroups(data));
});
registerMsgHandler(NOTIFY_CREATE_GROUP, (payload) => {
    const data = JSON.parse(payload) as CompGroup;

    console.debug(data);

    groupStore.dispatch(groupSliceActions.addGroup(data));
});
registerMsgHandler(NOTIFY_UPDATE_GROUP, (payload) => {
    const data = JSON.parse(payload) as CompGroup;

    console.debug(data);

    groupStore.dispatch(groupSliceActions.updateGroup(data));
});
registerMsgHandler(NOTIFY_REMOVE_GROUP, (payload) => {
    const data = JSON.parse(payload) as StringID;

    console.debug(data);

    groupStore.dispatch(groupSliceActions.removeGroup(data));
});
